import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import './style.scss';

const Admin = (props) => {
  const {
    nationalTopics,
    setNewNationalTopics,
  } = props;

  const [isEditingNationalTopics, setIsEditingNationalTopics] = useState(false);

  const [natlTopicMap, setNatlTopicMap] = useState([]);

  useEffect(() => {
    setNatlTopicMap(nationalTopics.reduce((acc, { title, description }) => ([
      ...acc,
      [title, description],
    ]), []));
  }, [nationalTopics]);

  const updateNatlTopicValue = offset => index => (e) => {
    const updatedMap = [...natlTopicMap];
    updatedMap[index][offset] = e.target.value;
    setNatlTopicMap(updatedMap);
  };

  const updateNatlTopicMapTitle = updateNatlTopicValue(0);
  const updateNatlTopicMapDescription = updateNatlTopicValue(1);

  const addNatlTopic = () => setNatlTopicMap(map => [...map, ['', '']]);
  const deleteNatlTopic = title => setNatlTopicMap(map => map.filter(topic => topic[0] !== title));

  const saveNatlTopicChanges = () => {
    const newNationalTopics = natlTopicMap.reduce((acc, [title, description]) => ({
      ...acc,
      [title]: description,
    }), {});

    setNewNationalTopics(newNationalTopics);
    setIsEditingNationalTopics(false);
  };

  const discardNatlTopicChanges = () => {
    setNatlTopicMap(nationalTopics.reduce((acc, { title, description }) => ([
      ...acc,
      [title, description],
    ]), []));

    setIsEditingNationalTopics(false);
  };

  return (
    <div id="admin-content">
      <h1>Admin Portal</h1>
      <Link className="admin-home-button" to="/admin">Go To Admin Home</Link>
      <div id="national-topics-container" className="admin-container">
        <h3>National Topics</h3>
        <table>
          <tr>
            <th>UI Description</th>
            <th>Search Phrase</th>
          </tr>
          {!isEditingNationalTopics && nationalTopics.map(topic => (
            <tr key={topic.title}>
              <td>{topic.description}</td>
              <td>{topic.title}</td>
            </tr>
          ))}
          {isEditingNationalTopics && natlTopicMap.map(([title, description], index) => (
            <tr className="edit-row">
              <td><input value={description} onChange={updateNatlTopicMapDescription(index)} /></td>
              <td><input value={title} onChange={updateNatlTopicMapTitle(index)} /></td>
              <td><button type="button" onClick={() => deleteNatlTopic(title)}>Delete Topic</button></td>
            </tr>
          ))}
        </table>
        <div id="natl-topic-button-container">
          {isEditingNationalTopics ? (
            <div id="edit-button-container">
              <button type="button" onClick={saveNatlTopicChanges}>Save Changes</button>
              <button type="button" onClick={discardNatlTopicChanges}>Discard Changes</button>
              <button type="button" onClick={addNatlTopic}>Add Topic</button>
            </div>
          ) : (
            <button type="button" onClick={() => setIsEditingNationalTopics(true)}>Edit National Topics</button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Admin;
